/**
 * Mirror of @repo/ui/lib/external-link (marketing-ui does not depend on @repo/ui, as cn.ts explains).
 * Rule (connect0 skill §Q.13, spec 120): a link that leaves connect0 opens
 * in a new tab. The page the visitor is on is the product; a third-party
 * site — a server's repo, a vendor's docs, an evidence link — must not
 * replace it.
 *
 * `externalLinkProps(href)` is the one place that decides what "leaves
 * connect0" means, so a primitive that accepts any `href` can spread it
 * and be right for every caller. `rel="noopener noreferrer"` rides along
 * because `target="_blank"` without it hands the opened page a handle on
 * ours.
 */
const OWN_HOSTS = /(^|\.)connect0\.ai$/i;

export function isExternalHref(href: string | undefined | null): boolean {
  if (!href) return false;
  if (!/^https?:\/\//i.test(href)) return false;
  try {
    return !OWN_HOSTS.test(new URL(href).hostname);
  } catch {
    return false;
  }
}

export function externalLinkProps(href: string | undefined | null): { target?: '_blank'; rel?: string } {
  return isExternalHref(href) ? { target: '_blank', rel: 'noopener noreferrer' } : {};
}
